<template>
  <div class="look-list">
    <!-- 录带看房源列表 弹屏 -->
    <a-modal
      v-model="isLookList"
      destroyOnClose
      :footer="null"
      :maskClosable="false"
      :closable="false"
      :width="700"
      centered
    >
      <div class="content-follow">
        <div class="title">
          <a-icon @click="isLookListFn" style="font-size: 16px; cursor: pointer" type="close" />
          <span>房源列表</span>
          <span></span>
          <!-- <span style="font-size: 16px; color: var(--ThemeColor); cursor: pointer" @click="okFn">确认</span> -->
        </div>

        <a-form-model :model="houseInfo" :colon="false">
          <a-form-model-item label=" ">
            <a-input size="large" allowClear placeholder="智能搜索" @pressEnter="searchBtn" v-model="houseInfo.search" />
          </a-form-model-item>
          <a-form-model-item>
            <a-button type="primary" style="margin-left: 10px" @click="searchBtn"> 查询 </a-button>
          </a-form-model-item>
        </a-form-model>

        <!-- 房源列表内容 -->
        <div v-if="houseInfoList.length">
          <div v-for="v in houseInfoList" :key="v.id" @click="chooseOne(v)">
            <a-row class="house">
              <a-col :span="6">
                <img
                  width="150"
                  height="100"
                  v-if="v.houseInfoImgVo && v.houseInfoImgVo.interiorList"
                  :src="v.houseInfoImgVo.interiorList[0].url"
                  alt=""
                />
                <img width="150" height="100" v-else src="@/assets/images/nodataImg.svg" alt="" />
              </a-col>
              <a-col :span="17" style="padding-left: 10px">
                <h4 style="font-weight: 700; font-size: 16px">{{ v.shopName }}</h4>
                <div>
                  <span style="margin-right: 15px; color: #000">{{ v.businessDistrictName }} </span>
                  <span style="margin-right: 15px; color: #000">{{ v.streetName }} </span>
                  <span style="margin-right: 15px; color: #000">{{ v.grossFloorArea }} m²</span>
                  <span style="margin-right: 15px; color: #000" >{{ v.houseFloor || 1  }}层</span>
                  <span style="color: #ff7202; font-weight: 700">{{ v.salePrice | keepTwo_wan }}</span>
                </div>
                <span style="color: #000">编号 {{ v.houseCode }}</span>
              </a-col>
            </a-row>
          </div>
        </div>
        <!-- 分页 -->
        <a-pagination
          size="large"
          v-model="houseInfo.pageNum"
          :page-size="houseInfo.pageSize"
          :total="total"
          @change="changpage"
          show-less-items
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import sell_tourist from '@/api/system/tourist/sell_tourist.js'

export default {
  props: {
    isLookList: {
      type: Boolean,
      require: true,
    },
    houseStatus: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 请求参数
      houseInfo: {
        hourseSort: 1,
        houseResourceType: 1,
        pageNum: 1,
        pageSize: 4,
        sortType: 'ASC',
        search: '',
        houseStatus: this.houseStatus,
      },
      // 房源列表数据
      houseInfoList: [],
      total: 0,
    }
  },
  methods: {
    isLookListFn() {
      this.houseInfo.pageNum = 1
      this.houseInfo.pageSize = 4
      this.houseInfo.search = ''
      this.$emit('closeModal', false)
    },
    okFn() {
      this.$emit('okFn')
    },

    // 查询房源信息列表
    gethouseInfoListFn() {
      sell_tourist.gethouseInfoList({ ...this.houseInfo }).then((res) => {
        if (res.code === 200) {
          // console.log(res)
          this.houseInfoList = res.data.records
          // this.houseInfoList = this.houseInfoList.filter(el=>el.houseStatus == '1')
          // console.log(this.houseInfoList,'111')
          this.total = res.data.total
        }
      })
    },
    // 查询
    searchBtn() {
      this.gethouseInfoListFn()
    },
    // 页码改变
    changpage(page, pageSize) {
      this.houseInfo.pageNum = page
      this.houseInfo.pageSize = pageSize
      this.gethouseInfoListFn()
    },
    // 用户选择了房源
    chooseOne(v) {
      this.$emit('dataList', v)
      this.isLookListFn()
    },
  },
  watch: {
    isLookList() {
      if (this.isLookList === true) {
        this.gethouseInfoListFn()
      }
    },
  },
  // created() {
  //   this.gethouseInfoList()
  // },
}
</script>

<style lang="less" scoped>
.content-follow {
  height: 800px;
  .title {
    height: 20px;
    line-height: 20px;
    color: #000;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
  }

  .house {
    margin-top: 10px;
    padding: 10px 14px;
    width: 100%;
    height: 120px;
    background-color: #f9f7fb;
    border-radius: 10px;
    cursor: pointer;
  }
  /deep/.ant-pagination {
    position: absolute;
    bottom: 50px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
